import { forwardRef } from "react";
import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

interface LightningBoltProps {
  className?: string;
  size?: number;
  filled?: boolean;
  animate?: boolean;
  onClick?: () => void;
}

export const LightningBolt = forwardRef<SVGSVGElement, LightningBoltProps>(
  ({ className, size = 24, filled = false, animate = false, onClick }, ref) => {
    return (
      <motion.svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill={filled ? "currentColor" : "none"}
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={cn(
          "text-primary transition-colors duration-200",
          onClick && "cursor-pointer hover:text-primary/80",
          className
        )}
        onClick={onClick}
        whileTap={onClick ? { scale: 1.3 } : undefined}
        animate={animate ? { scale: [1, 1.2, 1] } : undefined}
        transition={{ duration: 0.3 }}
      >
        <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
      </motion.svg>
    );
  }
);

LightningBolt.displayName = "LightningBolt";

export const LightningDivider = ({ className }: { className?: string }) => (
  <div className={cn("flex items-center gap-4 my-6", className)}>
    <div className="flex-1 h-px bg-gradient-to-r from-transparent via-border to-transparent" />
    <LightningBolt size={16} className="text-primary/50" />
    <div className="flex-1 h-px bg-gradient-to-r from-transparent via-border to-transparent" />
  </div>
);

export const LoadingBolt = forwardRef<HTMLDivElement, { size?: number }>(
  ({ size = 32 }, ref) => (
    <div ref={ref} className="flex items-center justify-center">
      <LightningBolt
        size={size}
        filled
        className="loading-bolt text-primary"
      />
    </div>
  )
);

LoadingBolt.displayName = "LoadingBolt";
